import script from "./FileInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileInput.vue?vue&type=script&setup=true&lang=ts"

import "./FileInput.vue?vue&type=style&index=0&id=3d44a09f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d44a09f"]])

export default __exports__